export const ROUTES = {
  HOME: '/',
  SHOP: '/shop',
  MARKETING: '/marketing',
  FINANCE: '/finance',
  STATISTICS: '/statistics',
  SETTINGS: '/settings',
  DASHBOARD: '/dashboard',
  POLICY: '/privacy-policy-and-cookies',
  TERMS: '/terms-of-service',
  ACCEPTION: '/acceptation',
  SUBSCRIPTIONS: '/subscriptions',

  SERG_TEST_PAGE: '/serg-test-page',
};
